// extracted by mini-css-extract-plugin
export var chevron = "_18-d";
export var disabled = "_18-b";
export var error = "_18-c";
export var hideBorder = "_18-1";
export var icon = "_18-e";
export var input = "_18-0";
export var large = "_18-f";
export var open = "_18-9";
export var placeholder = "_18-a";
export var regular = "_18-5";
export var singleRowInput = "_18-2";
export var singleSelectInput = "_18-3 _18-0";
export var small = "_18-4";
export var spinnerContainer = "_18-i";
export var tag = "_18-7";
export var tagsContainer = "_18-8";
export var tagsInput = "_18-6 _18-0";
export var xSmall = "_18-g";
export var xxSmall = "_18-h";